module.exports = __webpack_public_path__ + "img/edge_patrimoine_industrie_2.dfce4558.svg";